const orders = {
  namespaced: true,
  state: {
    eligibleOffersList: [],
    haulageEligible: [],
    itemToAddToBasket: "",
    itemToEdit: "",
    doCountdown: false,
    filtersApplied: [],
    displayFilteredOrders: false,
    marketWindowId: "",
    totalVolumeInBasket: 0,
    isOrderPlaced: false,
    isOrderListUpdateAllowed: false,
  },
  getters: {
    getOrderIdReceiptData(state) {
      return state.orderIdReceipt;
    },
    marketWindowId(state) {
      return state.marketWindowId;
    },
    isOrderListUpdateAllowedGetter(state) {
      return state.isOrderListUpdateAllowed;
    },
    displayFilteredOrders(state) {
      return state.displayFilteredOrders;
    },
  },
  mutations: {
    SET_ORDER_COMPLETION_STATUS: (state, payload) => {
      state.isOrderPlaced = payload;
    },
    EDIT_ITEM: (state, payload) => {
      state.itemToEdit = payload;
    },
    ITEM_ADDED_TO_BASKET: (state) => {
      state.itemToAddToBasket = "";
    },
    FILTER_ORDERS: (state, payload) => {
      state.filtersApplied = [];
      state.filtersApplied = payload.filtersApplied;

      /* If filters selected are the same as default, set displayFilteredOrders to false */
      if (payload.filtersSameAsDefault == false) {
        state.displayFilteredOrders = true;
      } else {
        state.displayFilteredOrders = false;
      }
    },
    UPDATE_MARKET_WINDOW_ID: (state, id) => {
      state.marketWindowId = id;
    },
    ALLOW_UPDATE_ORDER_LIST: (state, newStatus) => {
      state.isOrderListUpdateAllowed = newStatus;
    },
  },
  actions: {
    setOrderCompletionStatus: ({ commit }, payload) => {
      commit("SET_ORDER_COMPLETION_STATUS", payload);
    },
    filterOrders: ({ commit }, response) => {
      commit("FILTER_ORDERS", response);
    },
    allowUpdateOrderList: ({ commit }, newStatus) => {
      commit("ALLOW_UPDATE_ORDER_LIST", newStatus);
    },
  },
};

export default orders